import { VisibilityFilters } from 'actions'
import { actions } from './actions'

const contractorActiveFilter = (state = { employerId: 0, filter: VisibilityFilters.SHOW_ACTIVE }, action) => {
  switch (action.type) {
    case actions.set:
      return action.contractorActiveFilter
    default:
      return state
  }
}

export default contractorActiveFilter



// WEBPACK FOOTER //
// ./src/store/contractor-active-filter/reducer.js